import { APPROVE_BIKE_STATUS_CONFIG } from '@/configs/constants';
import { ApproveBikeStatusType } from '@/types/enums';
import { useTranslation } from 'react-i18next';

export default function ApproveBikeStatus({ status }: { status: ApproveBikeStatusType | undefined }) {
    // hooks
    const { t } = useTranslation();

    return (
        status !== undefined ?
            (
                <span className={`px-1.5 py-0.5 ${APPROVE_BIKE_STATUS_CONFIG[status].textColor} text-nowrap`}>{t(`field.${APPROVE_BIKE_STATUS_CONFIG[status].key}`)}</span>
            ) :
            (
                <></>
            )
    );
}
